import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SignaturePad from '../components/SignaturePad';
import '../styles/HptScreens.css';
import Swal from 'sweetalert2';

// BackEnd de Serveless
const API_URL = process.env.REACT_APP_API_URL;

// ============================================================================
// COMPONENTE: ExpandableCard (Acordeón reutilizable)
// ============================================================================
const ExpandableCard = ({ title, icon, children, defaultOpen = false }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    return (
        <div className="expandable-card">
            <div className="card-header" onClick={() => setIsOpen(!isOpen)}>
                <span>{icon} {title}</span>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            {/* Si isOpen es true, le añade la clase 'open' para mostrar el contenido */}
            <div className={`card-content ${isOpen ? 'open' : ''}`}>
                {children}
            </div>
        </div>
    );
};


// ============================================================================
// COMPONENTE PRINCIPAL: CreatePTWDirectoScreen
// ============================================================================
const CreatePTWDirectoScreen = () => {
    const navigate = useNavigate();

    const token = localStorage.getItem('userToken');
    let userIdDefault = null;
    let userNameDefault = '';
    if (token) {
        try {
            const decoded = JSON.parse(atob(token.split('.')[1]));
            userIdDefault = decoded.id; 
            userNameDefault = `${decoded.user_name || ''} ${decoded.user_apelli || ''}`.trim() || decoded.user || '';
        } catch(e) {}
    }
    
    // --- ESTADOS DE DATOS (Servidor) ---
    const [activos, setActivos] = useState([]);       // Lista de activos
    const [usuarios, setUsuarios] = useState([]);     // Lista de Usuarios
    const [catalogo, setCatalogo] = useState([]);     // Catálogo general de riesgos y medidas de seguridad
    const [seleccionados, setSeleccionados] = useState([]); // Array con los IDs de los riesgos marcados
    const [showSignature, setShowSignature] = useState(false); // Modal de Firmas
    
    // --- ESTADOS DEL FORMULARIO PTW ---
    const [alcance, setAlcance] = useState('');
    // Pillamos el nombre del usuario directamente de la sesión (Local Storage)
    const [idActivo, setIdActivo] = useState(null);
    const [denActSnapshot, setDenActSnapshot] = useState(''); // Se guarda como texto por si el activo cambia de nombre
    const [otAsociada, setOtAsociada] = useState('');
    const [fechaTrabajo, setFechaTrabajo] = useState(new Date().toISOString().split('T')[0]); // Fecha de hoy por defecto
    const [diasPrevistos, setDiasPrevistos] = useState(1);
    const [rangoHorario, setRangoHorario] = useState('');
    const [localizaciones, setLocalizaciones] = useState([]);
    const [idLocalizacion, setIdLocalizacion] = useState('');
    const [descripcionTrabajo, setDescripcionTrabajo] = useState('');
    const [trabajosPreviosText, setTrabajosPreviosText] = useState('');

    // --- ESTADOS DEL BUSCADOR AUTOCOMPLETAR (ACTIVOS) ---
    const [busquedaActivo, setBusquedaActivo] = useState('');     // Texto a Escribir por el usuario
    const [mostrarDesplegable, setMostrarDesplegable] = useState(false); // MUestra resultados en columna
    const [opcionesActivos, setOpcionesActivos] = useState([]);   // Resultados de la búsqueda desde el servidor

    // --- ESTADOS DEL BUSCADOR DE SOLICITANTE ---
    const [busquedaSolicitante, setBusquedaSolicitante] = useState(userNameDefault);
    const [idSolicitante, setIdSolicitante] = useState(userIdDefault);
    const [mostrarDesplegableSolicitante, setMostrarDesplegableSolicitante] = useState(false);

    // --- ESTADOS DEL BUSCADOR DE RECURSO PREVENTIVO ---
    const [busquedaRP, setBusquedaRP] = useState('');
    const [mostrarDesplegableRP, setMostrarDesplegableRP] = useState(false);

    // --- ESTADOS CATÁLOGOS ELÉCTRICOS ---
    const [electricosBloqueo, setElectricosBloqueo] = useState([]);
    const [electricosDescargo, setElectricosDescargo] = useState([]);

    // --- ESTADOS DE DESCARGOS ---
    const [bloqueosElectricos, setBloqueosElectricos] = useState([]);
    const [descargosElectricos, setDescargosElectricos] = useState([]);
    const [descargosMecanicosText, setDescargosMecanicosText] = useState('');
    // --- Asociacion Manual de LOTOS OTRO PTW ---
    const [numManualBloqueo, setNumManualBloqueo] = useState('');
    const [numManualDescargo, setNumManualDescargo] = useState('');
    const [ptwVinculadoBloqueo, setPtwVinculadoBloqueo] = useState('');
    const [ptwVinculadoDescargo, setPtwVinculadoDescargo] = useState('');

    // ============================================================================
    // Efectos al montar Componente.
    // ============================================================================
    useEffect(() => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        const fetchData = async () => { 
            try {
                // Descargamos Activos y Catálogo de Seguridad a la vez
                const [resActivos, resCatalogo, resElecBloq, resElecDesc, resUsuarios, resLocs] = await Promise.all([
                    axios.get(`${API_URL}/api/catalogos/activos`, config),
                    axios.get(`${API_URL}/api/catalogos/seguridad`, config),
                    axios.get(`${API_URL}/api/catalogos/electricosBloqueo`, config),
                    axios.get(`${API_URL}/api/catalogos/electricosDescargo`, config),
                    axios.get(`${API_URL}/api/catalogos/usuarios`, config),
                    axios.get(`${API_URL}/api/catalogos/localizaciones`, config)
                ]);
                const extractData = (res) => res.data.results ? res.data.results : res.data;
                setActivos(extractData(resActivos));
                setCatalogo(extractData(resCatalogo));
                setElectricosBloqueo(extractData(resElecBloq));
                setElectricosDescargo(extractData(resElecDesc));
                setUsuarios(extractData(resUsuarios));
                setLocalizaciones(resLocs.data.results || resLocs.data);
            } catch (err) { console.error(err); }
        };
        fetchData();
    }, []);

    // ============================================================================
    // FUNCIONES PARA TARJETAS LOTO
    // ============================================================================
    // --- LÓGICA DE BLOQUEOS ELÉCTRICOS ---
    const addBloqueoElectrico = () => setBloqueosElectricos([...bloqueosElectricos, { num_consignacion: Math.floor(Math.random() * 1000000), id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '', textoBusqueda: '', mostrarDesplegable: false }]);
    const removeBloqueoElectrico = (idx) => setBloqueosElectricos(bloqueosElectricos.filter((_, i) => i !== idx));
    const handleFilaBloqueoChange = (idx, texto) => {
        const filas = [...bloqueosElectricos]; filas[idx].textoBusqueda = texto; filas[idx].mostrarDesplegable = texto.length >= 3;
        if(texto === '') { filas[idx].activo = ''; filas[idx].centro_cargas = ''; filas[idx].ubicacion = ''; filas[idx].tension = ''; filas[idx].descripcion = ''; }
        setBloqueosElectricos(filas);
    };
    const seleccionarElementoBloqueoElectrico = (idx, elem) => {
        const filas = [...bloqueosElectricos];
        filas[idx] = { ...filas[idx], id_item: elem.id_item, activo: elem.activo, centro_cargas: elem.centro_cargas || 'S/C', ubicacion: elem.ubicacion || 'S/U', tension: elem.tension, descripcion: elem.descripcion || '', textoBusqueda: elem.activo, mostrarDesplegable: false };
        setBloqueosElectricos(filas);
    };
    const addBloqueoManual = () => {
        if (!numManualBloqueo) return;
        setBloqueosElectricos([...bloqueosElectricos, {
            num_consignacion: parseInt(numManualBloqueo),
            id_item: '', activo: 'MANUAL', centro_cargas: '-', ubicacion: '-', tension: 0,
            descripcion: ptwVinculadoBloqueo ? `LOTO vinculado al PTW: ${ptwVinculadoBloqueo}` : 'Consignación manual',
            textoBusqueda: ptwVinculadoBloqueo ? `[MANUAL] Nº ${numManualBloqueo} (PTW: ${ptwVinculadoBloqueo})` : `[MANUAL] Nº ${numManualBloqueo}`,
            mostrarDesplegable: false,
            ptw_vinculado: ptwVinculadoBloqueo || null //
        }]);
        setNumManualBloqueo('');
        setPtwVinculadoBloqueo('');
    };

    // --- LÓGICA DE DESCARGOS ELÉCTRICOS ---
    const addDescargoElectrico = () => setDescargosElectricos([...descargosElectricos, { num_consignacion: Math.floor(Math.random() * 1000000), id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '', textoBusqueda: '', mostrarDesplegable: false }]);
    const removeDescargoElectrico = (idx) => setDescargosElectricos(descargosElectricos.filter((_, i) => i !== idx));
    const handleFilaDescargoChange = (idx, texto) => {
        const filas = [...descargosElectricos]; filas[idx].textoBusqueda = texto; filas[idx].mostrarDesplegable = texto.length >= 3;
        if(texto === '') { filas[idx].activo = ''; filas[idx].centro_cargas = ''; filas[idx].ubicacion = ''; filas[idx].tension = ''; filas[idx].descripcion = ''; }
        setDescargosElectricos(filas);
    };
    const seleccionarElementoDescargoElectrico = (idx, elem) => {
        const filas = [...descargosElectricos];
        filas[idx] = { ...filas[idx], id_item: elem.id_item, activo: elem.activo, centro_cargas: elem.centro_cargas || 'S/C', ubicacion: elem.ubicacion || 'S/U', tension: elem.tension, descripcion: elem.descripcion || '', textoBusqueda: elem.activo, mostrarDesplegable: false };
        setDescargosElectricos(filas);
    };
    const addDescargoManual = () => {
        if (!numManualDescargo) return;
        setDescargosElectricos([...descargosElectricos, {
            num_consignacion: parseInt(numManualDescargo),
            id_item: '', activo: 'MANUAL', centro_cargas: '-', ubicacion: '-', tension: 0,
            descripcion: ptwVinculadoDescargo ? `LOTO vinculado al PTW: ${ptwVinculadoDescargo}` : 'Consignación manual',
            textoBusqueda: ptwVinculadoDescargo ? `[MANUAL] Nº ${numManualDescargo} (PTW: ${ptwVinculadoDescargo})` : `[MANUAL] Nº ${numManualDescargo}`,
            mostrarDesplegable: false,
            ptw_vinculado: ptwVinculadoDescargo || null 
        }]);
        setNumManualDescargo('');
        setPtwVinculadoDescargo('');
    };

    // ============================================================================
    // FUNCIONES AUXILIARES
    // ============================================================================
    // Alterna el estado de los checkbox
    const toggleItem = (idItem) => {
        setSeleccionados(prev => prev.includes(idItem) 
            ? prev.filter(i => i !== idItem) // Si ya estaba, lo quitamos
            : [...prev, idItem]              // Si no estaba, lo metemos
        );
    };

    // ============================================================================
    // FUNCIONES: BUSCADOR DE ACTIVOS (AUTOCOMPLETAR)
    // ============================================================================
    // Se ejecuta al escribir en el campo "codigo activo"
    const buscarActivosEnServidor = async (texto) => {
        setBusquedaActivo(texto);
        
        // Al menos tres letras, para realizar peticiones al servidor
        if (texto.length < 2) {
            setOpcionesActivos([]);
            return;
        }

        try {
            const token = localStorage.getItem('userToken');
            const res = await axios.get(`${API_URL}/api/catalogos/activos/buscar?q=${texto}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Guarda los resultados en el estado para mostrarlos en la lista desplegable
            setOpcionesActivos(res.data.results || []);
        } catch (err) {
            console.error("Error buscando activos:", err);
        }
    };

    // Al hacer clic en una opción de la lista desplegable
    const seleccionarActivo = (activo) => {
        setIdActivo(activo.id_activo);
        setDenActSnapshot(activo.denominacion);
        setBusquedaActivo(activo.codigo_activo); // Deja el código en el input
        setMostrarDesplegable(false); // Cierra la lista
    };

    // ============================================================================
    // GUARDADO (Envío al Backend)
    // ============================================================================
    const handleGuardarNuevo = async () => {
        const token = localStorage.getItem('userToken');

        

        // 1. Construcción del Payload para mandar al Backend.
        const payload = {
            alcance: alcance,
            descripcion_trabajo: descripcionTrabajo,
            id_activo: parseInt(idActivo) || undefined, 
            id_localizacion: parseInt(idLocalizacion) || undefined,
            id_solicitante: parseInt(idSolicitante) || undefined, 
            solicitante_nombre: busquedaSolicitante,
            recurso_preventivo_nombre: busquedaRP,
            den_act_snapshot: denActSnapshot,
            ot_asociada: otAsociada || null,
            fecha_trabajo: fechaTrabajo, 
            rango_horario: rangoHorario || null,
            dias_previstos: parseInt(diasPrevistos) || 1,
            estado: 'creado', // Estado inicial del permiso
            
            // Aseguramos que los IDs de seguridad sean INT para la base de datos
            seleccionados_seguridad: seleccionados.map(id => parseInt(id)),

            // Empaquetamos en JSON
            descargos: {
                bloqueos_electricos: bloqueosElectricos.filter(b => b.activo !== ''),
                descargos_electricos: descargosElectricos.filter(d => d.activo !== ''),
                descargos_mecanicos: descargosMecanicosText.split(',').map(s => s.trim()).filter(Boolean),
                trabajos_previos: trabajosPreviosText.split(',').map(s => s.trim()).filter(Boolean)
            },
            
            // Campos vacíos por defecto obligatorios para la estructura del backend
            firmas_secciones: {},
            renovaciones: []
        };

        console.log("Enviando Payload:", payload); 

        // 2. Envío al servidor
        try {
            await axios.post(`${API_URL}/api/ptw`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
            alert("✅ Permiso Directo creado con éxito.");
            navigate('/dashboard'); // Si todo correcto, volvemos a Dashboard
        } catch (err) {
            // Si da algun fallo mostraemos error
            const erroresZod = err.response?.data?.detalles;
            const errorText = err.response?.data?.error || err.response?.data?.detail;
            
            console.error("Detalle del error:", erroresZod || errorText);
            
            if (err.response?.status === 400 && erroresZod) {
                // Mostramos un alert bonito si nos hemos saltado algún campo obligatorio
                Swal.fire('Faltan datos', `Revisa los campos obligatorios.\n\nFallo detectado por el servidor:\n${JSON.stringify(erroresZod, null, 2)}`, 'warning');
            } else {
                Swal.fire('Error', errorText || 'Error al conectar con el servidor.', 'error');
            }
        }
    };

    // Extraemos solo las categorías de los elementos marcados como "Riesgo" en el catálogo
    const categoriasRiesgo = [...new Set(catalogo.filter(i => i.es_riesgo).map(i => i.categoria))];
    
    // ============================================================================
    // RENDER (HTML/JSX)
    // ============================================================================
    return (
        <div className="container">
            {/* --- CABECERA --- */}
            <div className="top-header header-ptw">
                <div className="d-flex align-center">
                    <span className="ptw-label">NUEVO PERMISO:</span>
                    <div className="ptw-badge">
                        <span style={{ fontSize: '20px' }}>⚡</span> DIRECTO
                    </div>
                </div>
                <div className="header-actions">
                    <button onClick={handleGuardarNuevo} className="btn-save">💾 Crear y Guardar</button>
                    <button onClick={() => navigate('/dashboard')} className="btn-close">Cancelar</button>
                </div>
            </div>

            {/* --- SECCIÓN PRINCIPAL: DATOS BÁSICOS --- */}
            <div className="main-card">
                <div className="row">
                    <div className="d-flex" style={{ flex: 2, flexDirection: 'column' }}>
                        <label className="info-label">ALCANCE DEL TRABAJO:</label>
                        <textarea 
                            placeholder="Describe el trabajo..." 
                            value={alcance} 
                            onChange={e => setAlcance(e.target.value)} 
                            className="main-textarea" 
                        />
                    </div>
                    <div className="field relative">
                        <label className="info-label">SOLICITANTE (Buscador):</label>
                        <input 
                            type="text" 
                            className="input-solicitante w-100" 
                            placeholder="Buscar nombre o apellidos..."
                            value={busquedaSolicitante}
                            onChange={(e) => {
                                setBusquedaSolicitante(e.target.value);
                                setMostrarDesplegableSolicitante(true);
                                setIdSolicitante(null); // Borramos el ID si cambia el texto manualmente
                            }}
                            onFocus={() => setMostrarDesplegableSolicitante(true)}
                            onBlur={() => setTimeout(() => setMostrarDesplegableSolicitante(false), 200)}
                        />
                        
                        {/* Lista flotante de usuarios filtrados localmente */}
                        {mostrarDesplegableSolicitante && busquedaSolicitante.length >= 2 && (
                            <ul className="autocomplete-list">
                                {usuarios.filter(u => 
                                    u.nombre.toLowerCase().includes(busquedaSolicitante.toLowerCase()) || 
                                    u.apellidos.toLowerCase().includes(busquedaSolicitante.toLowerCase()) ||
                                    u.usuario.toLowerCase().includes(busquedaSolicitante.toLowerCase())
                                ).map(u => (
                                    <li 
                                        key={u.id_usuario} 
                                        className="autocomplete-item"
                                        onMouseDown={() => {
                                            setIdSolicitante(u.id_usuario);
                                            setBusquedaSolicitante(`${u.nombre} ${u.apellidos}`);
                                            setMostrarDesplegableSolicitante(false);
                                        }}
                                    >
                                        <strong>{u.nombre} {u.apellidos}</strong> <br/>
                                        <span className="text-small text-muted">{u.rol} — {u.grupo}</span>
                                    </li>
                                ))}
                                
                                {usuarios.filter(u => 
                                    u.nombre.toLowerCase().includes(busquedaSolicitante.toLowerCase()) || 
                                    u.apellidos.toLowerCase().includes(busquedaSolicitante.toLowerCase())
                                ).length === 0 && (
                                    <li className="autocomplete-item">No se encontraron usuarios...</li>
                                )}
                            </ul>
                        )}
                    </div>
                </div>
                
                <div className="row">
                    {/* BUSCADOR DE ACTIVOS (AUTOCOMPLETAR) */}
                    <div className="info-box flex-1 relative">
                        <span className="info-label">CÓDIGO ACTIVO (Buscador):</span>
                        
                        <input 
                            type="text" 
                            className="main-input" 
                            placeholder="Escriba código o nombre..."
                            value={busquedaActivo}
                            onChange={(e) => {
                                buscarActivosEnServidor(e.target.value);
                                setMostrarDesplegable(true);
                                // Si borra el texto, reseteamos el activo seleccionado
                                if (idActivo) {
                                    setIdActivo(null);
                                    setDenActSnapshot('');
                                }
                            }}
                            onFocus={() => setMostrarDesplegable(true)}
                            // Se usa un timeout para que de tiempo a pulsar la opción antes de que desaparezca
                            onBlur={() => setTimeout(() => setMostrarDesplegable(false), 200)}
                        />
                        {/* Lista flotante de resultados del buscador */}
                        {mostrarDesplegable && busquedaActivo.length >= 2 && (
                            <ul className="autocomplete-list">
                                {opcionesActivos.length > 0 ? (
                                    opcionesActivos.map(a => (
                                        <li 
                                            key={a.id_activo} 
                                            className="autocomplete-item"
                                            onMouseDown={() => seleccionarActivo(a)} 
                                        >
                                            <strong>{a.codigo_activo}</strong> <br/>
                                            <span className="text-small text-muted">{a.denominacion}</span>
                                        </li>
                                    ))
                                ) : (
                                    <li className="autocomplete-item">No se encontraron activos...</li>
                                )}
                            </ul>
                        )}
                    </div>
                    <div className="field">
                        <label className="info-label">DENOMINACIÓN:</label>
                        {/* Campo bloqueado (readOnly) porque se autocompleta con el Select anterior */}
                        <input value={denActSnapshot} readOnly className="read-only" />
                    </div>
                    <div className="field">
                        <label className="info-label">OT (Opcional):</label>
                        <input value={otAsociada} onChange={e => setOtAsociada(e.target.value)} className="main-input" />
                    </div>
                </div>

                <div className="row">
                    <div className="field">
                        <label className="info-label">FECHA Y DÍAS PREVISTOS:</label>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <input 
                                type="date" 
                                value={fechaTrabajo} 
                                onChange={e => setFechaTrabajo(e.target.value)} 
                                className="main-input" 
                                style={{ flex: 2 }}
                            />
                            <input 
                                type="number" 
                                min="1" 
                                max="100" 
                                value={diasPrevistos} 
                                onChange={e => setDiasPrevistos(e.target.value)} 
                                className="main-input" 
                                style={{ flex: 1, textAlign: 'center' }} 
                                title="Días previstos de duración"
                            />
                            <span style={{ fontWeight: 'bold', color: '#1a237e' }}>Días</span>
                        </div>
                    </div>
                    <div className="field">
                        <label className="info-label">HORARIO:</label>
                        <input placeholder="08:00 - 16:00" value={rangoHorario} onChange={e => setRangoHorario(e.target.value)} className="main-input" />
                    </div>
                </div>
                <div className="row">
                    <div className="field relative">
                        <label className="info-label">RECURSO PREVENTIVO (Buscador):</label>
                        <input 
                            type="text" 
                            className="main-input w-100" 
                            placeholder="Buscar nombre o apellidos..."
                            value={busquedaRP}
                            onChange={(e) => {
                                setBusquedaRP(e.target.value);
                                setMostrarDesplegableRP(true);
                            }}
                            onFocus={() => setMostrarDesplegableRP(true)}
                            onBlur={() => setTimeout(() => setMostrarDesplegableRP(false), 200)}
                        />
                        
                        {/* Lista flotante de usuarios filtrados localmente */}
                        {mostrarDesplegableRP && busquedaRP.length >= 2 && (
                            <ul className="autocomplete-list">
                                {usuarios.filter(u => 
                                    u.nombre.toLowerCase().includes(busquedaRP.toLowerCase()) || 
                                    u.apellidos.toLowerCase().includes(busquedaRP.toLowerCase()) ||
                                    u.usuario.toLowerCase().includes(busquedaRP.toLowerCase())
                                ).map(u => (
                                    <li 
                                        key={`rp-${u.id_usuario}`} 
                                        className="autocomplete-item"
                                        onMouseDown={() => {
                                            // Al hacer clic, escribimos su nombre completo en el input
                                            setBusquedaRP(`${u.nombre} ${u.apellidos}`);
                                            setMostrarDesplegableRP(false);
                                        }}
                                    >
                                        <strong>{u.nombre} {u.apellidos}</strong> <br/>
                                        <span className="text-small text-muted">{u.rol} — {u.grupo}</span>
                                    </li>
                                ))}
                                
                                {usuarios.filter(u => 
                                    u.nombre.toLowerCase().includes(busquedaRP.toLowerCase()) || 
                                    u.apellidos.toLowerCase().includes(busquedaRP.toLowerCase())
                                ).length === 0 && (
                                    <li className="autocomplete-item">No se encontraron usuarios...</li>
                                )}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
            

            

            {/* --- SECCIÓN: DESCARGOS Y BLOQUEOS LOTO --- */}
            <ExpandableCard title="Descargos Requeridos" icon="⚙️">
                
                {/* BLOQUEOS ELÉCTRICOS */}
                <div className="loto-wrapper" style={{ marginTop: '0' }}>
                    <div className="loto-title-panel">🔒 BLOQUEOS ELÉCTRICOS</div>
                    <table className="table">
                        <thead>
                            <tr className="table-header">
                                <th className="th" style={{ width: '30%' }}>Tag Activo</th>
                                <th className="th" style={{ width: '20%' }}>Centro Cargas</th>
                                <th className="th" style={{ width: '30%' }}>Panel/Celda</th>
                                <th className="th" style={{ width: '10%' }}>Tensión</th>
                                <th className="th" style={{ width: '10%', textAlign: 'center' }}>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bloqueosElectricos.map((bloqueo, idx) => (
                                <tr key={idx}>
                                    <td className="td relative">
                                        <input 
                                            type="text" 
                                            className="main-input w-100 loto-yellow-input" 
                                            value={bloqueo.textoBusqueda} 
                                            onChange={(e) => handleFilaBloqueoChange(idx, e.target.value)} 
                                            onFocus={() => { 
                                                const n = [...bloqueosElectricos]; 
                                                n[idx].mostrarDesplegable = n[idx].textoBusqueda.length >= 3; 
                                                setBloqueosElectricos(n); 
                                            }} 
                                            onBlur={() => setTimeout(() => { 
                                                const n = [...bloqueosElectricos]; 
                                                n[idx].mostrarDesplegable = false; 
                                                setBloqueosElectricos(n); 
                                            }, 200)} 
                                        />
                                        {bloqueo.mostrarDesplegable && bloqueo.textoBusqueda.length >= 3 && (
                                            <ul className="autocomplete-list loto-dropdown">
                                                {electricosBloqueo.filter(e => e.activo.toLowerCase().includes(bloqueo.textoBusqueda.toLowerCase())).map(elem => (
                                                    <li key={elem.id_item} className="autocomplete-item loto-dropdown-item" onMouseDown={() => seleccionarElementoBloqueoElectrico(idx, elem)}>
                                                        <strong>{elem.activo}</strong> — {elem.centro_cargas}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </td>
                                    <td className="td loto-readonly">{bloqueo.centro_cargas}</td>
                                    <td className="td loto-readonly">{bloqueo.ubicacion}</td>
                                    <td className="td loto-readonly text-center">{bloqueo.tension} V</td>
                                    <td className="td text-center"><button type="button" className="del-btn" onClick={() => removeBloqueoElectrico(idx)}>Quitar</button></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                        <button type="button" className="add-btn" style={{ marginTop: 0 }} onClick={addBloqueoElectrico}>
                            + Añadir Bloqueo (Buscador)
                        </button>
                        <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                            <input type="number" className="main-input" placeholder="Nº Bloqueo" value={numManualBloqueo} onChange={(e) => setNumManualBloqueo(e.target.value)} style={{ width: '100px' }} />
                            <input type="text" className="main-input" placeholder="PTW (Opcional)" value={ptwVinculadoBloqueo} onChange={(e) => setPtwVinculadoBloqueo(e.target.value)} style={{ width: '130px' }} />
                            <button type="button" className="btn-save" style={{ padding: '6px 12px' }} onClick={addBloqueoManual}>Vincular</button>
                        </div>
                    </div>
                </div>

                {/* DESCARGOS ELÉCTRICOS */}
                <div className="loto-wrapper" style={{ marginTop: '20px', borderColors: '#2e7d32' }}>
                    <div className="loto-title-panel" style={{ color: '#2e7d32' }}>⚡ DESCARGOS ELÉCTRICOS</div>
                    <table className="table">
                        <thead>
                            <tr className="table-header">
                                <th className="th" style={{ width: '30%' }}>Tag Activo</th>
                                <th className="th" style={{ width: '20%' }}>Centro Cargas</th>
                                <th className="th" style={{ width: '30%' }}>Panel/Celda</th>
                                <th className="th" style={{ width: '10%' }}>Tensión</th>
                                <th className="th" style={{ width: '10%', textAlign: 'center' }}>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {descargosElectricos.map((descargo, idx) => (
                                <tr key={idx}>
                                    <td className="td relative">
                                        <input 
                                            type="text" 
                                            className="main-input w-100 loto-yellow-input" 
                                            value={descargo.textoBusqueda} 
                                            onChange={(e) => handleFilaDescargoChange(idx, e.target.value)} 
                                            onFocus={() => { 
                                                const n = [...descargosElectricos]; 
                                                n[idx].mostrarDesplegable = n[idx].textoBusqueda.length >= 3; 
                                                setDescargosElectricos(n); 
                                            }} 
                                            onBlur={() => setTimeout(() => { 
                                                const n = [...descargosElectricos]; 
                                                n[idx].mostrarDesplegable = false; 
                                                setDescargosElectricos(n); 
                                            }, 200)} 
                                        />
                                        {descargo.mostrarDesplegable && descargo.textoBusqueda.length >= 3 && (
                                            <ul className="autocomplete-list loto-dropdown">
                                                {electricosDescargo.filter(e => e.activo.toLowerCase().includes(descargo.textoBusqueda.toLowerCase())).map(elem => (
                                                    <li key={elem.id_item} className="autocomplete-item loto-dropdown-item" onMouseDown={() => seleccionarElementoDescargoElectrico(idx, elem)}>
                                                        <strong>{elem.activo}</strong> — {elem.centro_cargas}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </td>
                                    <td className="td loto-readonly">{descargo.centro_cargas}</td>
                                    <td className="td loto-readonly">{descargo.ubicacion}</td>
                                    <td className="td loto-readonly text-center">{descargo.tension} V</td>
                                    <td className="td text-center"><button type="button" className="del-btn" onClick={() => removeDescargoElectrico(idx)}>Quitar</button></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                        <button type="button" className="add-btn" style={{ backgroundColor: '#2e7d32', marginTop: 0 }} onClick={addDescargoElectrico}>
                            + Añadir Descargo (Buscador)
                        </button>
                        <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                            <input type="number" className="main-input" placeholder="Nº Descargo" value={numManualDescargo} onChange={(e) => setNumManualDescargo(e.target.value)} style={{ width: '100px' }} />
                            <input type="text" className="main-input" placeholder="PTW (Opcional)" value={ptwVinculadoDescargo} onChange={(e) => setPtwVinculadoDescargo(e.target.value)} style={{ width: '130px' }} />
                            <button type="button" className="btn-save" style={{ padding: '6px 12px' }} onClick={addDescargoManual}>Vincular</button>
                        </div>
                    </div>
                </div>

                {/* DESCARGOS MECÁNICOS */}
                <div className="loto-wrapper" style={{ marginTop: '20px', borderColor: '#f57c00' }}>
                    <div className="loto-title-panel" style={{ color: '#f57c00' }}>🔧 Descargos Mecánicos</div>
                    <input 
                        type="text" 
                        className="main-input w-100" 
                        placeholder="Ej: DM-1234, DM-999 (Sepáralos por comas)" 
                        value={descargosMecanicosText}
                        onChange={(e) => setDescargosMecanicosText(e.target.value)}
                    />
                </div>
            </ExpandableCard>

            {/* --- SECCIÓN: RIESGOS Y MEDIDAS --- */}
            <ExpandableCard title="Selección de Riesgos y Medidas" icon="🚨">
                <div className="category-grid">
                    {categoriasRiesgo.map(cat => (
                        <div key={cat} className="cat-block">
                            <div className="cat-title">{cat}</div>
                            <div className="grid-checks-auto">
                                {/* Filtramos el catálogo global para mostrar solo los de esta categoría */}
                                {catalogo.filter(i => i.categoria === cat).map(item => {
                                    const isSelected = seleccionados.includes(item.id_item);
                                    
                                    // Pintamos de rojo si es riesgo o de verde si es medida
                                    let badgeClass = 'check-item';
                                    if (isSelected) {
                                        badgeClass += item.es_riesgo ? ' checked-risk' : ' checked-measure';
                                    }

                                    return (
                                        <label key={item.id_item} className={badgeClass}>
                                            <input type="checkbox" checked={isSelected} onChange={() => toggleItem(item.id_item)} />
                                            <span><strong>{item.codigo}</strong> - {item.descripcion}</span>
                                        </label>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </ExpandableCard>
        </div>
    );
};

export default CreatePTWDirectoScreen;